@import 'styles/variables';
@import 'styles/mixins';

.container {
  padding: 4px 6px;
  border: 1px solid $grey-10;
  border-radius: 14px;
  display: flex;
  align-items: center;
  height: 28px;
  background: $white;
  @include xs-medium;
  @include transition(0.2s);
}

.emoji {
  height: 14px;
  font-size: 14px;
}

.count {
  margin-left: 2px;
}

.active {
  border-color: $blue-20;
  background-color: $blue-5;
  color: $blue-50;
}
